import { ThemeModule } from '../../front/lib/ThemeModule';
import { addGoogleDfpCmd, SizeMappings, AdFormats, onGoogleDfpServicesEnabled, onGoogleDfpNotLoaded, } from '../../front/ads';
import { addLayoutResizeListener, removeLayoutResizeListener } from '../../front/lib/utils';
import { dispatchGtmEvent } from '../../front/gtm';
export class Advert extends ThemeModule {
    constructor() {
        super(...arguments);
        this.dfpUnitEl = this.getElementById('dfpUnit');
        this.internalEl = this.getElementById('internal');
        this.placeholderComment = document.createComment('Hidden advert');
    }
    init() {
        if (this.internalEl) {
            this.root.classList.add('has--internalAd');
            this.internalEl.addEventListener('click', (event) => {
                var _a, _b;
                const a = event.target.closest('a');
                if ((a === null || a === void 0 ? void 0 : a.href) === ((_a = this.internalEl) === null || _a === void 0 ? void 0 : _a.dataset.href)) {
                    dispatchGtmEvent('SKP.InternalAd.click', {
                        url: a.href,
                        label: (_b = this.internalEl) === null || _b === void 0 ? void 0 : _b.dataset.title,
                    });
                }
            });
        }
        if (this.json.dfp && this.dfpUnitEl) {
            this.initDfp();
        }
        this.initCssProps();
    }
    initCssProps() {
        let propsTimeout = null;
        const initCssProps = () => {
            if (propsTimeout) {
                window.clearTimeout(propsTimeout);
            }
            propsTimeout = window.setTimeout(() => {
                this.root.style.setProperty('--width-num', this.root.clientWidth + '');
            }, 16);
        };
        initCssProps();
        addLayoutResizeListener(initCssProps);
        this.addCleanupHandler(() => removeLayoutResizeListener(initCssProps));
    }
    onFailedDfp() {
        if (!this.internalEl) {
            this.removeFromDOM();
        }
    }
    removeFromDOM() {
        this.root.replaceWith(this.placeholderComment);
    }
    restoreDOM() {
        if (!this.root.parentElement && this.placeholderComment.parentElement) {
            this.placeholderComment.replaceWith(this.root);
        }
    }
    initDfp() {
        const unitId = this.json.dfp.unitId;
        const networkCode = this.json.dfp.networkCode;
        const unitPath = `/${networkCode}/${unitId}`;
        const domId = this.dfpUnitEl.id;
        onGoogleDfpNotLoaded(() => this.onFailedDfp());
        addGoogleDfpCmd(() => {
            const format = AdFormats[this.json.size];
            const slot = googletag.defineSlot(unitPath, format, domId);
            if (slot) {
                const refresher = () => googletag.pubads().refresh([slot]);
                const sizeMapping = SizeMappings[this.json.size]();
                slot.defineSizeMapping(sizeMapping);
                slot.addService(googletag.pubads());
                onGoogleDfpServicesEnabled(() => {
                    googletag.display(slot);
                    addLayoutResizeListener(refresher, {
                        debounce: 250,
                        skipOnLoad: true,
                    });
                    this.addCleanupHandler(() => removeLayoutResizeListener(refresher));
                });
                const onSlotRenderEnded = (event) => {
                    if (event.slot.getSlotId().getDomId() === domId) {
                        if (event.isEmpty) {
                            this.root.classList.add('dfp--missing');
                            this.root.classList.remove('dfp--ready');
                            //removeLayoutResizeListener(refresher);
                            //this.onFailedDfp();
                        }
                        else {
                            this.root.classList.remove('dfp--missing');
                            this.root.classList.add('dfp--ready');
                            //this.root.setAttribute('data-accent-color', 'gray');
                            //this.root.className = this.root.className.replace(/internal--\S+/g, '');
                            //this.internalEl?.parentElement?.removeChild(this.internalEl);
                        }
                    }
                };
                this.addCleanupHandler(() => googletag.pubads().removeEventListener('slotRenderEnded', onSlotRenderEnded));
                googletag.pubads().addEventListener('slotRenderEnded', onSlotRenderEnded);
            }
        });
    }
}
